import { render, staticRenderFns } from "./StaffManage.vue?vue&type=template&id=1ba1b7f4"
import script from "./StaffManage.vue?vue&type=script&lang=ts"
export * from "./StaffManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports